import { HStack } from '@terra/ui-styled-system';
import { Clipboard, IconButton, Text, Tooltip } from '@terra/ui-design-system';
import { Tick01Icon, Copy01Icon, Edit01Icon } from '@terra/ui-icons';

type FindingLinkedTicketActionsProps = {
  linkedTicketUrl: string | null;
  showEditLinkedTicketAction: boolean;
  editLinkedTicketLabel: string;
  onEditLinkedTicket: () => void;
  isEditDisabled?: boolean;
  editDisabledTooltip?: string;
};

export function FindingLinkedTicketActions({
  linkedTicketUrl,
  showEditLinkedTicketAction,
  editLinkedTicketLabel,
  onEditLinkedTicket,
  isEditDisabled = false,
  editDisabledTooltip,
}: FindingLinkedTicketActionsProps) {
  if (!linkedTicketUrl) {
    return null;
  }

  return (
    <HStack gap={1} minW={0}>
      <Tooltip title={linkedTicketUrl}>
        <Text
          fontSize="sm"
          color="fg.default"
          maxW="280px"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {linkedTicketUrl}
        </Text>
      </Tooltip>
      <Clipboard.Root value={linkedTicketUrl}>
        <Clipboard.Trigger asChild>
          <IconButton
            variant="ghost"
            size="xs"
            aria-label="Copy linked ticket URL"
          >
            <Clipboard.Indicator copied={<Tick01Icon size={14} />}>
              <Copy01Icon size={14} />
            </Clipboard.Indicator>
          </IconButton>
        </Clipboard.Trigger>
      </Clipboard.Root>
      {showEditLinkedTicketAction && (
        <Tooltip
          title={
            isEditDisabled
              ? (editDisabledTooltip ?? editLinkedTicketLabel)
              : editLinkedTicketLabel
          }
        >
          <IconButton
            variant="ghost"
            size="xs"
            aria-label={editLinkedTicketLabel}
            onClick={onEditLinkedTicket}
            disabled={isEditDisabled}
          >
            <Edit01Icon size={14} />
          </IconButton>
        </Tooltip>
      )}
    </HStack>
  );
}
